import posthog from 'posthog-js';
import { AppInfo } from '../environment';

type FeatureFlagNames = keyof typeof AppInfo.Environment.runTimeFeatures;

export namespace FeatureFlags {
  let initialised = false;
  let featureFlags: Partial<Record<FeatureFlagNames, boolean>> = {};

  export function initialise(): void {
    posthog.onFeatureFlags((_flags: string[], variants: Record<string, string | boolean>) => {
      featureFlags = variants as Record<FeatureFlagNames, boolean>;
      initialised = true;
    });
  }

  export function getFeatureFlag(key: keyof typeof AppInfo.Environment.runTimeFeatures): any {
    // Save calls to posthog outside of initial load
    if (initialised) {
      return featureFlags[key] ?? AppInfo.Environment.runTimeFeatures[key];
    }

    return posthog.isFeatureEnabled(key) ?? AppInfo.Environment.runTimeFeatures[key];
  }

  export function getFeatureFlagPayload<T>(key: FeatureFlagNames): T | undefined {
    return (posthog.getFeatureFlagResult(key)?.payload as T) ?? undefined;
  }
}
